export default "__VITE_ASSET__szPkulTO__"